import Common_Btn from "../../common/common-btn/Common_Btn";
import "./Banner.css";

function Banner() {
  const handleScrollToDownload = () => {
    const section = document.getElementById("download_now");

    if (section) {
      section.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };
  return (
    <section id="banner" className="home_banner">
      <div className="container-fluid  p-0">
        <div className="banner_holder">
          <div className="banner_img_holder">
            <img
              src="/Assets/images/Banner/banner.png"
              alt="banner-img"
              className="banner_img"
            />
          </div>

          <div className="banner_content_holder">
            <p className="line_1">Unleash Your Best Self with</p>
            <p className="gymify">
              Gym<span>ify</span>
            </p>
            <p className="line_2">Your Fitness Journey, Simplified.</p>

            <div className="download_btn_holder">
              <Common_Btn
                btnText={"Download App"}
                onClick={handleScrollToDownload}
              />
            </div>
          </div>
          <div className="right_content_holder">
            <h2 className="right_content">
              Platform for <br /> Gym Members & Owners
            </h2>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Banner;
